import { render } from "./ProjectReport.vue?vue&type=template&id=52c7cf76"
import script from "./ProjectReport.vue?vue&type=script&lang=js"
export * from "./ProjectReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__